import React from 'react'

import { classNames } from '@/utils/helpers'

interface IconLoadingProps {
  progressColor?: string
  circleColor?: string
}

export const IconLoading = ({
  className,
  progressColor,
  circleColor,
  strokeWidth,
  ...props
}: React.ComponentProps<'svg'> & IconLoadingProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
    viewBox="0 0 24 24"
    className={classNames('-ml-1 mr-3 h-5 w-5', className)}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke={circleColor ?? '#D8D9DD'}
      strokeWidth={strokeWidth ?? 4}
    />
    <path
      fill={progressColor ?? '#1E84E3'}
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
)
